import Vue from 'vue'
import Store from '@/store'

function flatMenuList(treeMenuList) {
	let menus = []
	function flat(menuList) {
		menus.push(...menuList)
		menuList.forEach(element => {
			if (element.children.length) {
				flat(element.children)
			}
		})
	}
	flat(treeMenuList)
	return menus
}

Vue.directive('permission', {
	inserted: (el, bind) => {
		let menus = flatMenuList(Store.state.menuList)
		let matchMenu = menus.find(it => it.url === bind.value[0])
		if (!matchMenu || matchMenu.visible === '1') {
			// el.style.display = 'none'
			el.remove()
		}
	}
})

// 数字输入框数字长度限制
Vue.directive('numberMaxLength', {
	inserted: (el, bind, oldVnode) => {
		el.addEventListener('input', e => {
			let value = e.target.value
			if (e.target.value && e.target.value.length > bind.value) {
				oldVnode.child.$emit('input', value.slice(0, bind.value - 1))
			}
		})
	}
})

Vue.directive('numberDigitInput', {
	inserted: function (el, binding, oldVnode) {
		el.addEventListener('input', e => {
			if (e.target.value) {
				if (!/^(\d+)?(\.\d+)?$/.test(e.target.value)) {
					console.log(binding, oldVnode)
					let val = e.target.value.replace(/[^\d.]/g, '')
					console.log(val, '==')
					if (val.length == 0) {
						e.target.value = val
						oldVnode.child.$emit('input', val)
						console.log(e.target.value, '==')
						console.log(val, '==')
						return
					}
					if (val.split('.').length > 2) {
						let arr = val.split('.')
						let value = ''
						for (let i = 0; i < arr.length; i++) {
							value += arr[i]
							if (i === 0) {
								value += '.'
							}
						}
						val = value
					}
					e.target.value = val
					oldVnode.child.$emit('input', val)
				}
			}
		})

		el.addEventListener('blur', e => {
			if (e.target.value) {
				if (e.target.value.charAt(e.target.value.length - 1) === '.') {
					let val = e.target.value
					e.target.value = val.slice(0, -1)
				}
			}
		})
	}
})

Vue.directive('prohibitInput', {
	inserted: el => {
		const input = el.querySelector('input')
		input.addEventListener('keydown', function (e) {
			if (e.keyCode == 32) {
				e.preventDefault()
			}
		})
	}
})
